module.exports = __webpack_public_path__ + "static/media/it-software-consumables.5e2a6ef9.svg";